<!--
  Иконка водительского удостоверения: прямоугольная карточка с реквизитами.
  Обычно используется в блоках документов водителя и данных водительских прав.
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
      :stroke="stroke"
      stroke-width="2"
    />
    <path
      d="M7 10H11M7 14H13M16 10H17"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "LicenseIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
